module.exports = __webpack_public_path__ + "img/icon-helper.fe75e3ab.svg";